import _classCallCheck from "/var/www/sellox-gatsby-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/www/sellox-gatsby-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/var/www/sellox-gatsby-shop/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import { BehaviorSubject } from "rxjs";
import { filter, switchMap, tap } from "rxjs/operators";
import { authState } from "rxfire/auth";
import { collectionData, docData } from "rxfire/firestore";
import { Api } from "./utils";
import { CONFIG, firebase } from "./core";

var AuthModule = /*#__PURE__*/function () {
  function AuthModule() {
    _classCallCheck(this, AuthModule);

    this._user = new BehaviorSubject(null);
    this.user$ = this._user.asObservable();
  }

  _createClass(AuthModule, [{
    key: "user",
    get: function get() {
      return this._user.getValue();
    },
    set: function set(val) {
      if (!val) {
        this.createUser();
      } else {
        this._user.next(val);
      }
    }
  }, {
    key: "createUser",
    value: function createUser() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.updateFromAuth(this.auth);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "createCustomToken",
    value: function createCustomToken(tokenId) {
      return Api.post("".concat(CONFIG.shop.apiURL, "/auth/createCustomToken"), {
        token: tokenId
      });
    }
  }, {
    key: "setAuth",
    value: function setAuth(auth) {
      return firebase.auth().signInWithCustomToken(auth);
    }
    /**
     *
     */

  }, {
    key: "bootstrap",
    value: function bootstrap() {
      var _this = this;

      this.authState$ = authState(firebase.auth());
      this.authState$.pipe(tap(function (auth) {
        return _this.auth = auth;
      }), filter(function (auth) {
        return auth !== null;
      }), switchMap(function (auth) {
        return docData(firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("customers").doc(auth.uid));
      })).subscribe(function (val) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (val.uid) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 3;
                  return this.loginAnonymously();

                case 3:
                  return _context2.abrupt("return", _context2.sent);

                case 4:
                  this.user = val;
                  _context2.next = 7;
                  return firebase.auth().currentUser.getIdToken();

                case 7:
                  Api.token = _context2.sent;

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      });
    }
    /**
     *
     */

  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return firebase.auth().signOut();

              case 2:
                return _context3.abrupt("return", this.loginAnonymously());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     *
     * @param address
     */

  }, {
    key: "addAddress",
    value: function addAddress(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var addresses;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (Auth.user) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("user is not authenticated");

              case 2:
                addresses = Auth.user.addresses;
                addresses.push(address);
                return _context4.abrupt("return", firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("customers").doc(Auth.user.uid).update({
                  addresses: addresses
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
    /**
     *
     */

  }, {
    key: "getOrders",
    value: function getOrders() {
      var ordersRef = firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("orders").where("customer.uid", "==", Auth.user.uid);
      return collectionData(ordersRef, "$key");
    }
    /**
     *
     * @param data
     */

  }, {
    key: "login",
    value: function login(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$Api$post, token;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Api.post("".concat(CONFIG.shop.apiURL, "/auth/authenticate"), Object.assign({}, data));

              case 2:
                _yield$Api$post = _context5.sent;
                token = _yield$Api$post.token;
                _context5.next = 6;
                return firebase.auth().signInWithCustomToken(token);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
    /**
     *
     * @param data
     */

  }, {
    key: "register",
    value: function register(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$Api$post2, token;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.user) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return this.loginAnonymously();

              case 3:
                if (!this.user.isAnonymous) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 6;
                return Api.post("".concat(CONFIG.shop.apiURL, "/auth/register"), Object.assign(Object.assign({}, data), {
                  uid: this.user.uid
                }));

              case 6:
                _yield$Api$post2 = _context6.sent;
                token = _yield$Api$post2.token;
                _context6.next = 10;
                return firebase.auth().signInWithCustomToken(token);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     *
     * @param email
     */

  }, {
    key: "checkUserExist",
    value: function checkUserExist(email) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Api.post("".concat(CONFIG.shop.apiURL, "/auth/checkUserExist"), {
                  email: email
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
    /**
     *
     * @param changes
     */

  }, {
    key: "update",
    value: function update(changes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var updates, user;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.auth) {
                  _context8.next = 2;
                  break;
                }

                throw new Error("user is not logged it for this action");

              case 2:
                updates = [];
                user = firebase.auth().currentUser; // if (changes.password) {
                //   // updates.push(user.updatePassword(changes.password));
                // }
                // if (changes.email) {
                //   updates.push(user.updateEmail(changes.email.toLowerCase()));
                // }
                // if (changes.phone) {
                //   updates.push(user.updatePhoneNumber(changes.phone));
                // }
                // if (changes.name) {
                //   updates.push(user.updateProfile({ displayName: changes.name }));
                // }

                _context8.prev = 4;
                _context8.next = 7;
                return Promise.all(updates);

              case 7:
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](4);
                // if this fails huh sucks for you
                console.log(_context8.t0);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[4, 9]]);
      }));
    }
    /**
     *
     * @param auth
     */

  }, {
    key: "updateFromAuth",
    value: function updateFromAuth(auth) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (auth) {
                  _context9.next = 2;
                  break;
                }

                throw new Error("whoops! no auth to update");

              case 2:
                return _context9.abrupt("return", firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("customers").doc(auth.uid).update({
                  isAnonymous: auth.isAnonymous,
                  uid: auth.uid,
                  name: auth.displayName,
                  avatar: auth.photoURL,
                  phone: auth.phoneNumber || null,
                  email: auth.email || null
                }));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    }
    /**
     *
     * @param email
     */

  }, {
    key: "addGuestEmail",
    value: function addGuestEmail(email) {
      var user = firebase.auth().currentUser;
      return firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("customers").doc(user.uid).update({
        email: email
      });
    }
    /**
     * @return Promise
     */

  }, {
    key: "loginAnonymously",
    value: function loginAnonymously() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _yield$firebase$auth$, user;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return firebase.auth().signInAnonymously();

              case 2:
                _yield$firebase$auth$ = _context10.sent;
                user = _yield$firebase$auth$.user;
                console.log(user);
                return _context10.abrupt("return", firebase.firestore().collection("shops").doc(CONFIG.shop.$key).collection("customers").doc(user.uid).set({
                  isAnonymous: true,
                  uid: user.uid,
                  addresses: []
                }));

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    }
  }]);

  return AuthModule;
}();

export var Auth = new AuthModule();